import React from 'react';
import { Select, Input } from 'antd';
import {
  getRejectReasonLabel,
  isRejectReasonOther,
  sortRejectReasons,
} from '../../utils/rejectReasonUtils';

const { Option } = Select;

/**
 * انتخاب دلیل رد + فیلد توضیح در صورت «سایر»
 */
const RejectReasonFields = ({
  reasons = [],
  reasonId,
  reasonText = '',
  onReasonIdChange,
  onReasonTextChange,
  entityLabel = 'سرنخ',
}) => {
  const sorted = sortRejectReasons(reasons);
  const selected = sorted.find((r) => String(r.id) === String(reasonId));
  const showOther = isRejectReasonOther(selected);

  return (
    <div className="space-y-3" style={{ fontFamily: 'CustomFont' }}>
      <p className="text-sm text-gray-500 dark:text-gray-400 m-0">
        برای {entityLabel}، یکی از دلایل زیر را انتخاب کنید.
        {showOther ? ' در صورت انتخاب «سایر»، توضیح را نیز وارد کنید.' : ''}
      </p>
      <div>
        <label className="block text-xs text-gray-500 mb-1">دلیل رد</label>
        <Select
          value={reasonId != null && reasonId !== '' ? reasonId : undefined}
          onChange={onReasonIdChange}
          placeholder="انتخاب دلیل"
          style={{ width: '100%', fontFamily: 'CustomFont' }}
          allowClear
          showSearch
          optionFilterProp="children"
          autoFocus
        >
          {sorted.map((r) => (
            <Option key={r.id} value={r.id}>
              {getRejectReasonLabel(r)}
            </Option>
          ))}
        </Select>
      </div>
      {showOther ? (
        <div>
          <label className="block text-xs text-gray-500 mb-1">توضیح</label>
          <Input.TextArea
            rows={4}
            value={reasonText}
            onChange={(e) => onReasonTextChange?.(e.target.value)}
            placeholder="دلیل رد را بنویسید..."
          />
        </div>
      ) : null}
    </div>
  );
};

export default RejectReasonFields;
